//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Goods from '../../models/goods/goods'

export default {
    name: 'simpleDetail',
    data () {
        return {
            images: [],
            activeIndex: 0,
            pageState: 'loading',
            scrollTimer: null,
            progressTimers: {},
            previousTitle: '',
            fingerprint: '',
            challenge: null,
            challengeSubmitting: false,
            challengeError: ''
        }
    },
    mounted () {
        this.previousTitle = document.title
        document.title = '商品详情'
        this.fingerprint = this.buildFingerprint()
        this.loadImages()
    },
    beforeDestroy () {
        clearTimeout(this.scrollTimer)
        this.clearProgressTimers()
        document.title = this.previousTitle || '包买多了'
    },
    watch: {
        '$route.params.sku': function () {
            this.loadImages()
        }
    },
    methods: {
        loadImages () {
            this.clearProgressTimers()
            this.images = []
            this.activeIndex = 0
            this.pageState = 'loading'
            this.challenge = null
            this.challengeError = ''
            Goods.getSimpleDetail(this.$route.params.sku, this.fingerprint).then(res => {
                const payload = res.data.data || []
                if (payload.challengeRequired) {
                    this.challenge = payload
                    this.pageState = 'challenge'
                    return
                }
                const images = payload
                this.images = images.map(image => ({
                    imagesId: image.imagesId,
                    originalUrl: image.imageUrl,
                    thumbnailUrl: this.sizedImageUrl(image.imageUrl, 240),
                    previewUrl: this.sizedImageUrl(image.imageUrl, 720),
                    largeUrl: this.sizedImageUrl(image.imageUrl, 1600),
                    thumbnailLoaded: false,
                    thumbnailFailed: false,
                    previewRequested: false,
                    previewLoaded: false,
                    previewFailed: false,
                    largeRequested: false,
                    largeLoaded: false,
                    largeFailed: false,
                    loadProgress: 0
                }))
                this.pageState = this.images.length ? 'ready' : 'empty'
                if (this.images.length) {
                    this.$nextTick(() => this.requestPreviewImage(0))
                }
            }).catch(() => {
                this.images = []
                this.pageState = 'empty'
            })
        },
        submitChallenge (event) {
            if (!this.challenge || this.challengeSubmitting) return
            const image = event.currentTarget.querySelector('img')
            const rect = image.getBoundingClientRect()
            const x = Math.round((event.clientX - rect.left) * this.challenge.width / rect.width)
            const y = Math.round((event.clientY - rect.top) * this.challenge.height / rect.height)
            this.challengeSubmitting = true
            this.challengeError = ''
            Goods.verifySimpleChallenge({challengeId: this.challenge.challengeId, x, y}, this.fingerprint)
                .then(res => {
                    const result = res.data.data || {}
                    if (result.passed) this.loadImages()
                    else if (result.permanentBan) this.challengeError = '验证失败，当前访问已被限制'
                    else if (result.expired) {
                        this.challengeError = '验证码已过期，正在刷新'
                        this.loadImages()
                    } else this.challengeError = '位置不正确，请再试一次'
                })
                .catch(() => { this.challengeError = '验证暂时不可用，请稍后重试' })
                .then(() => { this.challengeSubmitting = false })
        },
        buildFingerprint () {
            const screenValue = window.screen ? [screen.width, screen.height, screen.colorDepth].join('x') : ''
            const values = [
                navigator.userAgent, navigator.language, navigator.platform,
                navigator.hardwareConcurrency || '', navigator.deviceMemory || '',
                navigator.maxTouchPoints || '', screenValue,
                new Date().getTimezoneOffset(), this.canvasSignal(), this.webglSignal()
            ].join('|')
            let first = 2166136261
            let second = 2246822519
            for (let i = 0; i < values.length; i++) {
                first = Math.imul(first ^ values.charCodeAt(i), 16777619)
                second = Math.imul(second ^ values.charCodeAt(i), 3266489917)
            }
            return ('00000000' + (first >>> 0).toString(16)).slice(-8) +
                ('00000000' + (second >>> 0).toString(16)).slice(-8)
        },
        canvasSignal () {
            try {
                const canvas = document.createElement('canvas')
                canvas.width = 180
                canvas.height = 40
                const context = canvas.getContext('2d')
                context.fillStyle = '#17324d'
                context.fillRect(3, 4, 91, 29)
                context.font = '15px serif'
                context.fillStyle = '#61c6ff'
                context.fillText('包买多了 801015', 8, 25)
                return canvas.toDataURL().slice(-160)
            } catch (error) { return '' }
        },
        webglSignal () {
            try {
                const gl = document.createElement('canvas').getContext('webgl')
                if (!gl) return ''
                const extension = gl.getExtension('WEBGL_debug_renderer_info')
                return extension ? gl.getParameter(extension.UNMASKED_VENDOR_WEBGL) + '|' +
                    gl.getParameter(extension.UNMASKED_RENDERER_WEBGL) : ''
            } catch (error) { return '' }
        },
        sizedImageUrl (url, size) {
            return (url || '')
                .replace('h_{height},w_{width}', 'h_' + size + ',w_' + size)
                .replace(/h_\d+,w_\d+/, 'h_' + size + ',w_' + size)
        },
        markThumbnailLoaded (image) {
            image.thumbnailLoaded = true
        },
        markThumbnailFailed (image) {
            image.thumbnailFailed = true
        },
        markPreviewLoaded (image, index) {
            image.previewLoaded = true
            if (image.previewRequested && index === this.activeIndex) {
                this.requestLargeImage(index)
            }
        },
        markPreviewFailed (image, index) {
            image.previewFailed = true
            if (image.previewRequested && index === this.activeIndex) {
                this.requestLargeImage(index)
            }
        },
        requestPreviewImage (index) {
            const image = this.images[index]
            if (!image) return
            if (!image.previewRequested) {
                image.previewLoaded = false
                image.previewRequested = true
                return
            }
            if (image.previewLoaded || image.previewFailed) {
                this.requestLargeImage(index)
            }
        },
        requestLargeImage (index) {
            const image = this.images[index]
            if (!image || image.largeRequested || image.largeLoaded) return
            image.largeRequested = true
            image.loadProgress = 8
            this.startProgress(image, index)
        },
        startProgress (image, index) {
            this.stopProgress(index)
            this.$set(this.progressTimers, index, setInterval(() => {
                if (image.largeLoaded || image.largeFailed) {
                    this.stopProgress(index)
                    return
                }
                const remaining = 90 - image.loadProgress
                image.loadProgress = Math.min(90, image.loadProgress + Math.max(1, Math.ceil(remaining * 0.12)))
            }, 180))
        },
        stopProgress (index) {
            if (!this.progressTimers[index]) return
            clearInterval(this.progressTimers[index])
            this.$delete(this.progressTimers, index)
        },
        clearProgressTimers () {
            Object.keys(this.progressTimers).forEach(index => this.stopProgress(index))
        },
        markLargeLoaded (image, index) {
            this.stopProgress(index)
            image.loadProgress = 100
            image.largeLoaded = true
        },
        markLargeFailed (image, index) {
            this.stopProgress(index)
            image.largeFailed = true
        },
        showImage (index) {
            const gallery = this.$refs.gallery
            if (!gallery) return
            const left = index * gallery.clientWidth
            if (typeof gallery.scrollTo === 'function') {
                try {
                    gallery.scrollTo({left, behavior: 'smooth'})
                } catch (error) {
                    gallery.scrollLeft = left
                }
            } else {
                gallery.scrollLeft = left
            }
            this.setActiveImage(index)
        },
        setActiveImage (index) {
            this.activeIndex = Math.max(0, Math.min(this.images.length - 1, index))
            this.requestPreviewImage(this.activeIndex)
            this.keepActiveThumbnailVisible()
        },
        handleGalleryScroll () {
            clearTimeout(this.scrollTimer)
            this.scrollTimer = setTimeout(() => {
                const gallery = this.$refs.gallery
                if (!gallery || !gallery.clientWidth) return
                this.setActiveImage(Math.round(gallery.scrollLeft / gallery.clientWidth))
            }, 80)
        },
        keepActiveThumbnailVisible () {
            this.$nextTick(() => {
                const strip = this.$refs.thumbnails
                if (!strip) return
                const active = strip.children[this.activeIndex]
                if (!active) return
                const left = active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2
                strip.scrollLeft = Math.max(0, left)
            })
        },
        hideBrokenImage (event) {
            event.target.style.visibility = 'hidden'
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/homepage/simpleDetail.vue